// ----------------------------------------------------------------------
// <copyright file="Izenda.Izenda.ReportPartTypeManager.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartTypeManager
 */
!(function() {
  var ensure = require('ensure');
  var notFound = require('share/components/controls/Izenda.NotFound');
  var ReportPartActions = require('modules/ReportDesigner/Fields/ReportBody/ReportPartType/Izenda.ReportPartActions');
  var DISPLAY_SECTION = {
    Dashboard: 'Dashboard',
    Viewer: 'Viewer',
    Report: 'Report'
  };
  const { chain, filter, indexOf, placeholder } = require('lodash/fp');
  var reportPartManager = {};

  var notFoundReportPart = {
    component: {
      BackSide: notFound,
      FrontSide: notFound
    }
  };

  module.exports = {
    DISPLAY_SECTION: DISPLAY_SECTION,

    /**
     * Register your Report Part here
     * @param  {ReportPart} reportPart: reportPart
     * @param  {String} key
     * @return {array} the list objects data object
     * Sample: ReportPartTypeManager.registerReportPartType(ReportPartConfig, 'key')
     */
    registerReportPartType: function(reportPart, key) {
      ensure(reportPart, 'Invalid reportPart');
      ensure(key, 'Invalid reportPart key');

      reportPartManager[key] = reportPart;
    },

    /**
     * get Report Part
     * @param  {String} key
     * @return {ReportPart} reportPart
     */
    getReportPartType: function(key, properties) {
      properties = properties || 'value';
      var reportPart = chain(reportPartManager)
        .values()
        .find([properties, key])
        .value();
      return reportPart ? reportPart : notFoundReportPart;
    },

    getReportFrontSide: function(key, forDisplay) {
      var FrontSide = this.getReportPartType(key).component.FrontSide;
      var action = null;

      switch (forDisplay) {
        case DISPLAY_SECTION.Dashboard:
          action = ReportPartActions.dashboard;
          break;
        case DISPLAY_SECTION.Viewer:
          action = ReportPartActions.viewer;
          break;
        default:
          action = ReportPartActions.report;
      }
      return action(FrontSide);
    },

    /**
     * filter report part
     * @param  {Array or ReportPart} reportParts array of report part need to filter
     * @return {Array of ReportPart}             array of report part after
     */
    filterSupportedReports: function(reportParts) {
      var supportReportPart = placeholder(reportPartManager)
        .values()
        .map('value')
        .value();

      // Only get report part have type in registerReportPartType
      return filter(function(item) {
        return indexOf(item.type, supportReportPart) >= 0;
      }, reportParts);
    }
  };
})();



// WEBPACK FOOTER //
// ./ui/Izenda.ReportPartTypeManager.js